'use client';

import React, { Suspense } from 'react';
import ChatScreen from './components/ChatScreen';

function ChatPageInner() {
  return <ChatScreen />;
}

export default function ChatPage() {
  return (
    <Suspense fallback={
      <div className="min-h-screen gradient-bg flex items-center justify-center">
        <div className="w-8 h-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    }>
      <ChatPageInner />
    </Suspense>
  );
}